<div class="card border-0  h-100 shadow-sm team-status-widget">
  <div class="card-header bg-white border-bottom-0">
    <h5 class="card-title text-muted mb-0">
      {{'DASHBOARD.TEAM_STATUS_WIDGET.TITLE' | translate}} 
    </h5>
  </div>
  <div class="card-body d-flex flex-column">
    @if (isLoading) {
      <div class="text-center my-5">
        <div class="spinner-border text-primary" role="status">
          <span class="visually-hidden">{{ 'COMMON.LOADING' | translate }}</span>
        </div>
        <p class="mt-2 text-muted">{{ 'COMMON.LOADING' | translate }}</p>
      </div>
    } @else if (errorMessage) {
      <div class="alert alert-danger my-3" role="alert">
        <i class="bi bi-exclamation-triangle-fill me-2"></i> {{ errorMessage }}
      </div>
    } @else if (teamStatuses.length === 0) {
      <div class="alert alert-info my-3 text-center">
        <i class="bi bi-info-circle-fill me-2"></i> {{ 'COMMON.ERROR.NO_DATA' | translate }}: 
      </div>
    } @else {
      <div class="list-group list-group-flush flex-grow-1">
        @for (team of teamStatuses; track team.team_id) {
          <div class="list-group-item d-flex align-items-center justify-content-between p-2 m-3 mb-0 border rounded">
            <div class="col-8 col-md-9 team-info-column">
              <h6 class="mb-2">
                <a [routerLink]="['/teams', team.team_id]" class="text-primary text-decoration-none fw-semibold text-truncate d-block">
                  {{ team.team_name }}
                </a>
                </h6>
              <p class="mb-1">
                <span class="badge bg-secondary">{{ team.team_type }}</span>
              </p>
              @if (team.description) {
                <p class="description-text mb-0">{{ team.description }}</p>
              }
            </div>

            <div class="col-4 col-md-3 d-flex flex-column align-items-center justify-content-center text-center">
              <div class="team-status-chart-container position-relative rounded-circle mb-2" style="width: 60px; height: 60px;">
                <p-chart type="doughnut"
                        [data]="getChartData(team.staffing_percentage)"
                        [options]="getChartOptions()">
                </p-chart>
                <div class="percentage-overlay position-absolute top-50 start-50 translate-middle">
                  {{ team.staffing_percentage | number:'1.0-0' }}%
                </div>
              </div>
              <span class="badge rounded-pill {{ getStatusClass(team.status) }}">{{ team.status }}</span>
            </div>
          </div>
        }
      </div>
    }
  </div>
</div>